module.exports = __webpack_public_path__ + "static/media/img-thumbnail-virtualmoto@2x.1612755c.png";